var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Value',_vm._g(_vm._b({attrs:{"label":_vm.label,"elevation":_vm.elevation,"color":_vm.color,"rounded":_vm.rounded,"highlight":_vm.highlight,"width":_vm.width}},'Value',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }